import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { atualizarLogomarcaEvento } from '../../util/util';
import { getText, saveIdioma } from '../../util/translations';
import api from '../../services/api';
import logo from '../../images/logoaccess.png';
import '../Login/styles.css';
import { toast } from 'react-toastify';
import Processando from '../../components/Processando';
import { clearParticipantAuth, saveParticipantAuth } from '../../util/authSession';
import { rotaDoStep } from '../../util/fluxoConvite';

export default function LoginConfirmarDados({ match }) {
  const id = match.params.id;
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const contrato = params.get('contrato');
  const lang = params.get('lang');
  const logoStyle = {
    maxWidth: '100%',
    maxHeight: '48px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  };

  const buscar = () => {
    setIsLoading(true);
    setIsError(false);
    atualizarLogomarcaEvento();
    api({
      method: "get",
      action: '/dadosParticipante/' + id,
    }).then(response => {
      var dadosRecebidos = response.data.data;
      atualizarLogomarcaEvento(dadosRecebidos.evento);
      if (dadosRecebidos.idioma) {
        saveIdioma(dadosRecebidos.idioma);
      }

      //o back decide a próxima etapa (proximoStep). Nos estados TERMINAIS (nada a preencher: já
      //concluiu ou recusou o convite) faz login rápido (para ter token e logo) e vai direto para a
      //tela final correspondente; senão mostra o botão "iniciar cadastro".
      //'recusado' precisa entrar aqui junto com 'concluido': sem isso quem recusou reabria o link e
      //via o botão de iniciar cadastro, e antes disso caía na tela de presença confirmada.
      const stepTerminal = ['concluido', 'recusado'].includes(dadosRecebidos.proximoStep);
      if (stepTerminal) {
        api({ method: 'post', action: '/loginRapido/' + id })
          .then(loginResp => {
            saveParticipantAuth(loginResp.data);
            atualizarLogomarcaEvento(dadosRecebidos.evento);
          })
          .catch(() => {})
          .finally(() => {
            history.push(rotaDoStep(dadosRecebidos.proximoStep, {
              id,
              eventoId: dadosRecebidos.evento.id,
              contrato,
            }));
          });
      } else {
        setData(dadosRecebidos);
        setIsLoading(false);
      }
    }).catch(err => {
      setIsLoading(false);
      setIsError(true);
      const message = <>{getText('error',lang)} {getText('errorRefreshPage',lang)}</>;

      toast.error(message);
    });
  };//buscar

  async function salvar(e) {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await api({
        method: 'post',
        action: '/loginRapido/' + id,
      });
      var dadosRecebidos = response.data;

      saveParticipantAuth(dadosRecebidos);

      //o back já resolveu a próxima etapa no GET (data.proximoStep); só navegamos.
      history.push(rotaDoStep(data?.proximoStep, { id, eventoId: data?.evento?.id, contrato }));
    } catch (error) {
      toast.error(getText('error') + getText('errorRefreshPage'));
    } finally {
      setIsSubmitting(false);
    }
  } //salvar

  useEffect(() => { //onload
    clearParticipantAuth();
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div id="auth" style={
      (data?.evento?.cor !== undefined) ? {
        backgroundImage: "none",
        backgroundColor: data?.evento?.cor,
      } : {
        backgroundImage: "none",
        backgroundColor: "#AAAAAA",
      }
    }>
      {isLoading && <Processando idioma={lang || "both"} />}
      <div className="container">
        <div className="row">
          <div className="col-md-5 col-sm-12 mx-auto">
            <div className="card pt-4">
              <div className="card-body">
                <div className="text-center mb-5">
                  {localStorage.getItem('logomarcaEvento') && (!isLoading && !isError && data?.evento) ?
                    <img alt="" src={localStorage.getItem('logomarcaEvento')} style={logoStyle} className='mb-4' /> :
                    <img alt="" src={logo} style={logoStyle} className='mb-4' />
                  }
                  {data &&
                    <p>{getText('welcomeMessage')} <strong>{(data?.evento?.nomersvp ?? data?.evento?.nome ?? "")}</strong>!</p>
                  }
                </div>
                {!isLoading && !isError && data?.evento && (
                  <form onSubmit={salvar}>
                    <div className="clearfix">
                      <center>
                        <button disabled={isSubmitting} className="btn btn-primary" type="submit">{getText('startRegistration')}</button>
                      </center>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
